(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ErrorResponse500', '../model/Body', '../model/Error', '../model/BlendedPackage', '../model/CreatePackage', '../model/ErrorResponse400', '../model/HyperLinkDraft', '../model/PushPackage', '../model/InlineResponse200', '../model/Packages', '../model/Acquisition', '../model/UploadMedia', '../model/AddRating', '../model/Rating', '../model/HyperLinkRatings', '../model/SharedPackageAccountsList', '../model/CreateVersion', '../model/Versions'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ErrorResponse500'), require('../model/Body'), require('../model/Error'), require('../model/BlendedPackage'), require('../model/CreatePackage'), require('../model/ErrorResponse400'), require('../model/HyperLinkDraft'), require('../model/PushPackage'), require('../model/InlineResponse200'), require('../model/Packages'), require('../model/Acquisition'), require('../model/UploadMedia'), require('../model/AddRating'), require('../model/Rating'), require('../model/HyperLinkRatings'), require('../model/SharedPackageAccountsList'), require('../model/CreateVersion'), require('../model/Versions'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.LibraryApi = factory(root.Swagger.ApiClient, root.Swagger.ErrorResponse500, root.Swagger.Body, root.Swagger.Error, root.Swagger.BlendedPackage, root.Swagger.CreatePackage, root.Swagger.ErrorResponse400, root.Swagger.HyperLinkDraft, root.Swagger.PushPackage, root.Swagger.InlineResponse200, root.Swagger.Packages, root.Swagger.Acquisition, root.Swagger.UploadMedia, root.Swagger.AddRating, root.Swagger.Rating, root.Swagger.HyperLinkRatings, root.Swagger.SharedPackageAccountsList, root.Swagger.CreateVersion, root.Swagger.Versions);
  }
}(this, function(ApiClient, ErrorResponse500, Body, Error, BlendedPackage, CreatePackage, ErrorResponse400, HyperLinkDraft, PushPackage, InlineResponse200, Packages, Acquisition, UploadMedia, AddRating, Rating, HyperLinkRatings, SharedPackageAccountsList, CreateVersion, Versions) {
  'use strict';

  /**
   * Library service.
   * @module api/LibraryApi
   * @version 1.0.0
   */

  /**
   * Constructs a new LibraryApi. 
   * @alias module:api/LibraryApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the acceptAcquisition operation.
     * @callback module:api/LibraryApi~acceptAcquisitionCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * API to accept package.
     * To share,transfer, get, buy, extend and clone a package.
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/Body} body request data used to acquire package.
     * @param {module:api/LibraryApi~acceptAcquisitionCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.acceptAcquisition = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling acceptAcquisition";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling acceptAcquisition";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling acceptAcquisition";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling acceptAcquisition";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/acquisitions/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the canonicalDetails operation.
     * @callback module:api/LibraryApi~canonicalDetailsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~canonicalDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.canonicalDetails = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling canonicalDetails";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling canonicalDetails";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling canonicalDetails";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/canonical/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the canonicalDownload operation.
     * @callback module:api/LibraryApi~canonicalDownloadCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~canonicalDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.canonicalDownload = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling canonicalDownload";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling canonicalDownload";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling canonicalDownload";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/canonical/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createPackage operation.
     * @callback module:api/LibraryApi~createPackageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create Package.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {module:model/CreatePackage} body request data used to create package.
     * @param {module:api/LibraryApi~createPackageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.createPackage = function(sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling createPackage";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling createPackage";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the draftCreate operation.
     * @callback module:api/LibraryApi~draftCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create the hub package
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug.
     * @param {Object} opts Optional parameters
     * @param {String} opts.version version of package to be returned
     * @param {String} opts.force boolean that forces a pulled package to overwrite the local package
     * @param {module:api/LibraryApi~draftCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.draftCreate = function(sessionkey, accountSlug, slug, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling draftCreate";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling draftCreate";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling draftCreate";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
        'version': opts['version'],
        'force': opts['force']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/draft/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the draftDetails operation.
     * @callback module:api/LibraryApi~draftDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HyperLinkDraft} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~draftDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/HyperLinkDraft}
     */
    this.draftDetails = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling draftDetails";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling draftDetails";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling draftDetails";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = HyperLinkDraft;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/draft/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the draftDownload operation.
     * @callback module:api/LibraryApi~draftDownloadCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Pull a package&#39;s documents.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug.
     * @param {Object} opts Optional parameters
     * @param {String} opts.version version of package to be returned
     * @param {String} opts.force boolean that forces a pulled package to overwrite the local package
     * @param {String} opts.asHash boolean that will pull hashOnly
     * @param {module:api/LibraryApi~draftDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.draftDownload = function(sessionkey, accountSlug, slug, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling draftDownload";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling draftDownload";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling draftDownload";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
        'version': opts['version'],
        'force': opts['force'],
        'as_hash': opts['asHash']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/draft/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the draftUpdate operation.
     * @callback module:api/LibraryApi~draftUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Push a package&#39;s documents.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug.
     * @param {module:model/PushPackage} body request data used to push package.
     * @param {module:api/LibraryApi~draftUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/InlineResponse200}
     */
    this.draftUpdate = function(sessionkey, accountSlug, slug, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling draftUpdate";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling draftUpdate";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling draftUpdate";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling draftUpdate";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = InlineResponse200;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/draft/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getImage operation.
     * @callback module:api/LibraryApi~getImageCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Return URL of an image.REVIEW.
     * gets name of image and returns URL.
     * @param {String} name image name.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/LibraryApi~getImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {'String'}
     */
    this.getImage = function(name, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling getImage";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getImage";
      }


      var pathParams = {
        'name': name
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/images/{name}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the packageList operation.
     * @callback module:api/LibraryApi~packageListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Packages} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Packages.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {Object} opts Optional parameters
     * @param {String} opts.share value used to pass query parameter &#39;share&#39; in the url.
     * @param {String} opts.transferByMe value used to pass query parameter &#39;transfer_by_me&#39; in the url.
     * @param {String} opts.transferToMe value used to pass query parameter &#39;transfer_to_me&#39; in the url.
     * @param {module:api/LibraryApi~packageListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Packages}
     */
    this.packageList = function(sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling packageList";
      }


      var pathParams = {
      };
      var queryParams = {
        'share': opts['share'],
        'transfer_by_me': opts['transferByMe'],
        'transfer_to_me': opts['transferToMe']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Packages;

      return this.apiClient.callApi(
        '/packages/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the packageShare operation.
     * @callback module:api/LibraryApi~packageShareCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * API to acquire package between accounts.
     * To share,transfer, get, buy, extend and clone a package.
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/Acquisition} body request data used to acquire package.
     * @param {module:api/LibraryApi~packageShareCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.packageShare = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling packageShare";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling packageShare";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling packageShare";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling packageShare";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/acquisitions/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the packageUploadMedia operation.
     * @callback module:api/LibraryApi~packageUploadMediaCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a media file to package&#39;s draft
     * 
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage hub user session.
     * @param {module:model/UploadMedia} body request data used to update package.
     * @param {module:api/LibraryApi~packageUploadMediaCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.packageUploadMedia = function(slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling packageUploadMedia";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling packageUploadMedia";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling packageUploadMedia";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/media/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the preview operation.
     * @callback module:api/LibraryApi~previewCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Preview theme
     * 
     * @param {String} url theme url. Ex: &lt;theme&gt;/&lt;version&gt;/&lt;template&gt;/context_key=value&amp;context_key=value...
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/LibraryApi~previewCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {'String'}
     */
    this.preview = function(url, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'url' is set
      if (url == undefined || url == null) {
        throw "Missing the required parameter 'url' when calling preview";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling preview";
      }


      var pathParams = {
        'url': url
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/preview/{url}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ratingAdd operation.
     * @callback module:api/LibraryApi~ratingAddCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add a rating to a package.
     * 
     * @param {String} accountSlug account slug used to uniquely identify a account.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/AddRating} body request data used to add package rating.
     * @param {module:api/LibraryApi~ratingAddCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.ratingAdd = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling ratingAdd";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling ratingAdd";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling ratingAdd";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling ratingAdd";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/ratings/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ratingDetail operation.
     * @callback module:api/LibraryApi~ratingDetailCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Rating} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Details of package rating submitted by any user.
     * Returns package rating details.
     * @param {String} accountSlug account slug used to uniquely identify a account.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {Integer} ratingPk value used to uniquely identify rating.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~ratingDetailCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Rating}
     */
    this.ratingDetail = function(accountSlug, slug, ratingPk, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling ratingDetail";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling ratingDetail";
      }

      // verify the required parameter 'ratingPk' is set
      if (ratingPk == undefined || ratingPk == null) {
        throw "Missing the required parameter 'ratingPk' when calling ratingDetail";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling ratingDetail";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'rating_pk': ratingPk
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Rating;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/ratings/{rating_pk}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ratingUpdate operation.
     * @callback module:api/LibraryApi~ratingUpdateCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update rating of package.
     * API for user to update rating score.
     * @param {String} sessionkey value used to manage user session.
     * @param {String} accountSlug account slug used to uniquely identify a account.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {Integer} ratingPk value used to uniquely identify rating.
     * @param {module:model/AddRating} body request data used to update rating.
     * @param {module:api/LibraryApi~ratingUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.ratingUpdate = function(sessionkey, accountSlug, slug, ratingPk, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling ratingUpdate";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling ratingUpdate";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling ratingUpdate";
      }

      // verify the required parameter 'ratingPk' is set
      if (ratingPk == undefined || ratingPk == null) {
        throw "Missing the required parameter 'ratingPk' when calling ratingUpdate";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling ratingUpdate";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'rating_pk': ratingPk
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/ratings/{rating_pk}/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ratingsList operation.
     * @callback module:api/LibraryApi~ratingsListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HyperLinkRatings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns list of ratings submitted by users for a package.
     * 
     * @param {String} accountSlug account slug used to uniquely identify a account.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage hub user session.
     * @param {module:api/LibraryApi~ratingsListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/HyperLinkRatings}
     */
    this.ratingsList = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling ratingsList";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling ratingsList";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling ratingsList";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = HyperLinkRatings;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/ratings/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the saveImage operation.
     * @callback module:api/LibraryApi~saveImageCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Save Image into backend.REVIEW.
     * 
     * @param {String} name name of the image.
     * @param {String} sessionkey host sessionkey.
     * @param {Object} opts Optional parameters
     * @param {File} opts.image image file
     * @param {module:api/LibraryApi~saveImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {'String'}
     */
    this.saveImage = function(name, sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling saveImage";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling saveImage";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
        'name': name,
        'image': opts['image']
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/media/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sharedPackageListGet operation.
     * @callback module:api/LibraryApi~sharedPackageListGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SharedPackageAccountsList} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * API to acquire package between accounts.
     * To share,transfer, get, buy, extend and clone a package.
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {Object} opts Optional parameters
     * @param {String} opts.share value used to pass query parameter &#39;share&#39; in the url.
     * @param {module:api/LibraryApi~sharedPackageListGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SharedPackageAccountsList}
     */
    this.sharedPackageListGet = function(accountSlug, slug, sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling sharedPackageListGet";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling sharedPackageListGet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling sharedPackageListGet";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
        'share': opts['share']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SharedPackageAccountsList;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/acquisitions/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the versionCreateSnapshot operation.
     * @callback module:api/LibraryApi~versionCreateSnapshotCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a snapshot of a package.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/CreateVersion} body request data used to snapshot package.
     * @param {module:api/LibraryApi~versionCreateSnapshotCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.versionCreateSnapshot = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling versionCreateSnapshot";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling versionCreateSnapshot";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling versionCreateSnapshot";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling versionCreateSnapshot";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/versions/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the versionDetails operation.
     * @callback module:api/LibraryApi~versionDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HyperLinkDraft} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} label version of the package
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~versionDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/HyperLinkDraft}
     */
    this.versionDetails = function(accountSlug, slug, label, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling versionDetails";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling versionDetails";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling versionDetails";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling versionDetails";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'label': label
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = HyperLinkDraft;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/versions/{label}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the versionDownload operation.
     * @callback module:api/LibraryApi~versionDownloadCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get package draft.
     * 
     * @param {String} accountSlug accountSlug
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} label version of the package
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~versionDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.versionDownload = function(accountSlug, slug, label, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling versionDownload";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling versionDownload";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling versionDownload";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling versionDownload";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'label': label
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/versions/{label}/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the versionList operation.
     * @callback module:api/LibraryApi~versionListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Versions} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return the list of package version
     * 
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LibraryApi~versionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Versions}
     */
    this.versionList = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling versionList";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling versionList";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling versionList";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Versions;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/versions/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/api/LibraryApi.js
 ** module id = 273
 ** module chunks = 0
 **/